import InstallIcon from './component'

export default InstallIcon
